import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessaoStore } from '../store/sessao.store';

export const loginGuard: CanActivateFn = () => inject(SessaoStore).verificarValidade()
  ? inject(Router).createUrlTree(['/home']) : true;
